import { Heart, Plus } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { DietaryTags } from "./DietaryTags";
import type { EmbeddedItemType } from "../types/item";
import mealPlaceholder from "../assets/meal-placeholder.png";
import { useFavourites } from "@/contexts/FavouritesProvider";
import { toItem } from "@/utils/with";
import { useState } from "react";

interface MenuGridProps {
  items: EmbeddedItemType[];
  onItemClick: (item: EmbeddedItemType) => void;
  showTags?: boolean;
  hideAddButton?: boolean;
}

export function MenuGrid({
  items,
  onItemClick,
  showTags = false,
  hideAddButton = false,
}: MenuGridProps) {
  const { t } = useLanguage();
  const showAddButton = !hideAddButton;

  const [loadingFavourites, setLoadingFavourites] = useState<string[]>([]);

  console.log("from menu grid to bassel: ", items);

  const {
    favouriteItems,
    addFavouriteItem,
    removeFavouriteItem,
    isFavouriteItem,
  } = useFavourites();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      {items.map((item) => (
        <div
          key={item.id}
          className="cursor-pointer bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform "
        >
          <div className="cursor-pointer relative h-40 sm:h-48 overflow-hidden">
            <img
              src={item.image || mealPlaceholder}
              alt={item.name}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              onClick={() => onItemClick(item)}
            />
            <div className="absolute top-2 end-2 sm:top-4 sm:end-4 flex flex-col gap-2 z-10">
              {showAddButton && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onItemClick(item);
                  }}
                  className="cursor-pointer bg-primary hover:bg-primary/80 text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
                >
                  <Plus className="w-4 h-4 sm:w-5 sm:h-5" />
                </button>
              )}

              <button
                onClick={async (e) => {
                  e.stopPropagation();
                  if (isFavouriteItem(item.id)) {
                    setLoadingFavourites([...loadingFavourites, item.id]);
                    removeFavouriteItem(await toItem(item));
                    setLoadingFavourites(
                      loadingFavourites.filter((id) => id !== item.id)
                    );
                  } else {
                    setLoadingFavourites([...loadingFavourites, item.id]);
                    addFavouriteItem(await toItem(item));
                    setLoadingFavourites(
                      loadingFavourites.filter((id) => id !== item.id)
                    );
                  }
                }}
                className="cursor-pointer bg-primary hover:bg-primary/80 text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
              >
                <Heart
                  className="w-4 h-4 sm:w-5 sm:h-5"
                  fill={
                    isFavouriteItem(item.id) ||
                    loadingFavourites.includes(item.id)
                      ? "white"
                      : "none"
                  }
                />
              </button>
            </div>
            {/* <div className="flex flex-col">
              {showAddButton && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onItemClick(item);
                  }}
                  className="cursor-pointer absolute top-2 end-2 sm:top-4 sm:end-4 bg-primary hover:bg-primary/80 text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
                >
                  <Plus className="w-4 h-4 sm:w-5 sm:h-5" />
                </button>
              )}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onItemClick(item);
                }}
                className="cursor-pointer absolute top-2 end-2 sm:top-4 sm:end-4 bg-primary hover:bg-primary/80 text-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110"
              >
                <Heart className="w-4 h-4 sm:w-5 sm:h-5" />
              </button>
            </div> */}
          </div>
          <div
            className="p-4 sm:p-6 cursor-pointer"
            onClick={() => onItemClick(item)}
          >
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 hover:text-primary transition-colors item-name">
              {item.name}
            </h3>

            {showTags && (
              <DietaryTags
                foodName={item.name}
                description={item.description}
                showTags={true}
                className="mt-1"
              />
            )}
            {/* {item.company && (
              <div className="flex items-center mb-2">
                <span className="text-xs sm:text-sm text-blue-800 bg-blue-50 px-2 py-1 rounded-full capitalize-names mt-2">
                  {item.company.name}
                </span>
              </div>
            )} */}
            {item.description && (
              <p className="text-gray-600 mb-3 sm:mb-4 line-clamp-2 text-sm sm:text-base">
                {item.description}
              </p>
            )}

            <div className="flex flex-col items-start mt-3">
              <span className="text-xl sm:text-2xl font-bold text-primary self-end">
                ₪{item.price}
              </span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onItemClick(item);
                }}
                className="cursor-pointer text-primary hover:text-primary/80 text-xs sm:text-sm font-medium mt-1"
              >
                {t("item.view_details")}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
